import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { map, tap } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LevelProgStructure } from '../entities/levelProgStructure';
import { FiscalYear } from '../entities/fiscalYear';

@Injectable()
export class LevelProgStructureService extends BaseCrudService<LevelProgStructure> {

    public uri = '/api/levelProgStructure/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance LevelProgStructureService');
    }

    buildSentence(entity?: LevelProgStructure, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.digit ? 'digit'
                + QueryOperator.Equal + entity.digit
                + QueryOperator.Split : QueryOperator.Empty
            );

            if (entity.fiscalYear) {
                query = query.concat(
                    entity.fiscalYear.id ? 'fiscalYear.id'
                    + QueryOperator.Equal + entity.fiscalYear.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    getSequenceCode(fiscalYear : FiscalYear): Observable<string> {
        const url = this.rutaServidor + this.uri + 'maxCode/';
        return this.httpClient.post<any>(url, fiscalYear)
            .pipe(
                map(response => {
                    // debugger;
                    const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 3);
                    const sequence = (parseInt(code, 10)) + 1;
                    return FormatUtils.padLeftZero(sequence, 3);
                }),
                tap(response => {
                   //console.log(response);
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/level-prog-structure.service.ts